import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  query getSlaContent($filter: slaContentFilterInput) {
    getSlaContent(filter: $filter) {
      id
      url
      isActive
      error {
        statusCode
        message
      }
    }
  }
`;

const initialState: TYPES.SlaContentState = {
  result: null,
  error: null,
  loading: false
};

export const getSlaContentRequest = createAsyncThunk<
  TYPES.SlaContent,
  {filter?: TYPES.SlaContentFilterInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'sla_content/get_sla_content',
  async (
  params: {filter?: TYPES.SlaContentFilterInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.query({
        query: GRAPHQL,
        variables: params
      });
      return response.data.getSlaContent;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const getSlaContentSlice = createSlice({
  name: 'get_sla_content',
  initialState: initialState,
  reducers: {
    getSlaContentClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(getSlaContentRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(getSlaContentRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(getSlaContentRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { getSlaContentClear } = getSlaContentSlice.actions;

export const getSlaContent = createSelector(
  (state: RootState) => state.slaContent.getSlaContent.result,
  (state: RootState) => state.slaContent.getSlaContent.error,
  (state: RootState) => state.slaContent.getSlaContent.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default getSlaContentSlice.reducer;